export default __webpack_public_path__ + "215be4c0e917e76f5333d92f5bf88dc9.svg";